import AppsList from "components/AppsList"
import useT from "utils/useT"
import useFetchApps from "utils/useFetchApps"
import { fetchGames } from "queries"
import usePullToRefresh from "utils/usePullToRefresh"
import useFiltersStore from "stores/filters"

export const Games = () => {
  const price = useFiltersStore((state) => state.price)
  const t = useT()
  const {
    data: games,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useFetchApps({
    queryFn: ({ pageParam }) => fetchGames({ price, pageParam }),
    queryKey: price ? ["getGames", price] : ["getGames"],
  })
  usePullToRefresh({ refetch, element: "#games-card", page: "games" })

  return (
    <div id="games-card">
      <AppsList
        title={t.apps.latestGames}
        apps={games}
        isPending={isFetchingNextPage}
        endReached={fetchNextPage}
      />
    </div>
  )
}
export default Games
